/**
 * Baseball outcome cell: outcome label + optional odds.
 * Used by schedule results tab for baseball (sport 40).
 */
import React from 'react';
import { printOdd } from 'shared/utils/common';
import { vsOutcomeTypeKey } from 'lib/virtualSportsI18n';

function normalizeBaseballRaw(raw) {
  if (raw == null) return [];
  const arr = Array.isArray(raw) ? raw : [raw];
  return arr.map((x) => {
    if (x != null && typeof x === 'object' && 'result' in x) {
      return { result: String(x.result), odd: x.odd != null ? Number(x.odd) : null };
    }
    return { result: String(x), odd: null };
  });
}

/**
 * Render outcome label and odd. showOdds: when false (e.g. mobile summary), only outcome is shown.
 * Outcome label uses font-semibold to match football outcome style in expanded view.
 */
export default function BaseballOutcomeCell({ raw, t, oddsFormat = 'decimal', showOdds = true }) {
  const items = normalizeBaseballRaw(raw);
  if (items.length === 0) return <span className="text-muted-foreground">—</span>;

  return (
    <span className="inline-flex flex-wrap items-center gap-x-2 gap-y-1">
      {items.map((item, i) => (
        <span key={i} className="inline-flex items-center gap-1.5">
          <span className="text-sm font-semibold text-foreground">
            {t(vsOutcomeTypeKey(item.result, false))}
          </span>
          {showOdds && item.odd != null && (
            <span className="text-muted-foreground text-xs tabular-nums font-medium">
              {printOdd(item.odd, oddsFormat)}
            </span>
          )}
        </span>
      ))}
    </span>
  );
}
